<svg
  viewBox="0 0 100 100"
  [attr.width]="diameter"
  [attr.height]="diameter"
  class="progress-spinner__svg"
>
  <circle
    class="progress-spinner__circle"
    cx="50"
    cy="50"
    [attr.r]="circleRadius"
    [attr.stroke-width]="resolvedStrokeWidth"
    fill="none"
    stroke-linecap="round"
  />
</svg>
